module.exports = __webpack_public_path__ + "static/media/HelpActive.7527fd58.png";